import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesSettingsMain } from './modules/ui/Main';

const SettingsPage = (
  <SuspensePage>
    <PagesSettingsMain />
  </SuspensePage>
);

export default SettingsPage;
